import { render, staticRenderFns } from "./OnboardingChooseImportMethodModal.vue?vue&type=template&id=2e76498a&scoped=true"
import script from "./OnboardingChooseImportMethodModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseImportMethodModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseImportMethodModal.vue?vue&type=style&index=0&id=2e76498a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e76498a",
  null
  
)

export default component.exports